import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";
import InfiniteScroll from "react-infinite-scroll-component";

import { getBoothAll, getBoothSearch } from "../redux/actions/booths";
import { getBrandAll } from "../redux/actions/brands";

import {
  Select,
  MenuItem,
  TextField,
  InputLabel,
  FormControl,
  Stack,
} from "@mui/material";

import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";

class BoothAll extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies),
  };
  constructor(props) {
    super(props);
    this.state = {
      filter_idbrand: 0,
      filter_name: "",
      filter_boothkey: "",
      filter_perpage: 0,
      filter_order: "",
      filter_sort: "",
      perpage: [30, 50, 100, 250, 500, 1000],
      orderBy: [
        { id: "idbrand", name: "Brand" },
        { id: "boothkey", name: "Boothkey" },
        { id: "price", name: "Price" },
        { id: "name", name: "Name" },
      ],
      sortBy: [
        { id: "ASC", name: "Ascending" },
        { id: "DESC", name: "Descending" },
      ],
      brand: [],
      data: [],
      err: null,
      is_loading: false,
      hasMore: true,
      page: 1,
    };

    this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
  }

  handleChangeFilter(e, f) {
    this.setState({ [e.target.name]: e.target.value });
  }

  params = () => {
    let params = {};
    if (this.state.filter_idbrand !== 0 && this.state.filter_idbrand !== "0") {
      params.idbrand = this.state.filter_idbrand;
    }
    if (this.state.filter_name !== "") {
      params.name = this.state.filter_name;
    }
    if (this.state.filter_boothkey !== "") {
      params.boothkey = this.state.filter_boothkey;
    }
    if (this.state.filter_order !== "") {
      params.order = this.state.filter_order;
    }
    if (this.state.filter_sort !== "") {
      params.sort = this.state.filter_sort;
    }
    params.perpage = this.state.perpage[this.state.filter_perpage];
    params.page = 1;
    params.is_active = 1;

    return params;
  };

  handleFilterSubmit(e) {
    this.setState({ is_loading: true });
    e.preventDefault();
    const doc = document.getElementsByClassName("infinite-scroll-component");
    if (doc[0]) {
      doc[0].scrollTo({
        top: 0,
        // behavior: "smooth",
      });
    }

    let params = this.params();

    const { cookies } = this.props;
    let expires = new Date();
    let data = {
      filter_idbrand: this.state.filter_idbrand,
      filter_name: this.state.filter_name,
      filter_boothkey: this.state.filter_boothkey,
      filter_perpage: this.state.filter_perpage,
      filter_order: this.state.filter_order,
      filter_sort: this.state.filter_sort,
    };
    expires.setTime(expires.getTime() + 1 * 24 * 60 * 60 * 1000);
    cookies.set("booth_cookies", data, { path: "/", expires: expires });

    this.props.getBoothAll(params).then((e) => {
      if (e.code === 200) {
        if (e.data !== null) {
          this.setState({
            data: e.data,
            is_loading: false,
            hasMore: e.data.length !== params.perpage ? false : true,
            page: 1,
          });
        } else {
          this.setState({
            data: [],
            is_loading: false,
            hasMore: false,
            page: 1,
          });
        }
      } else {
        this.setState({ data: [], is_loading: false });
      }
    });
  }

  componentDidUpdate(prevProv, prevState) {
    if (prevProv.cookies !== this.props.cookies) {
      this.fetchCookies();
    }
  }

  fetchCookies = () => {
    var brand_filter = this.props.cookies.get("brand_filter");
    if (brand_filter !== undefined) {
      this.setState({
        filter_idbrand: brand_filter,
      });
    }
    var booth_cookies = this.props.cookies.get("booth_cookies");
    if (booth_cookies !== undefined) {
      this.setState(
        {
          filter_idbrand: booth_cookies.filter_idbrand,
          filter_name: booth_cookies.filter_name,
          filter_boothkey: booth_cookies.filter_boothkey,
          filter_perpage: booth_cookies.filter_perpage,
          filter_order: booth_cookies.filter_order,
          filter_sort: booth_cookies.filter_sort,
        },
        () => {
          this.buttonElement.click();
        }
      );
    }
  };

  componentDidMount() {
    var ctx = this;
    this.props.getBrandAll().then((e) => {
      if (e.code === 200) {
        this.setState({ brand: e.data });
      }
    });

    this.props
      .getBoothAll({
        perpage: this.state.perpage[this.state.filter_perpage],
        page: this.state.page,
        is_active: 1,
      })
      .then(async (e) => {
        if (e.code === 200) {
          if (e.data !== null) {
            ctx.setState({
              data: e.data,
              hasMore:
                e.data.length !== this.state.perpage[this.state.filter_perpage]
                  ? false
                  : true,
            });
          } else {
            ctx.setState({ data: [], hasMore: false });
          }
        } else {
          ctx.setState({ err: e.message });
        }
        await this.fetchCookies();
      })
      .catch((e) => {
        alert("Something Error");
      });
  }

  handleFilterClear = (e) => {
    this.setState(
      {
        filter_idbrand: 0,
        filter_name: "",
        filter_boothkey: "",
        filter_perpage: 0,
        filter_order: "",
        filter_sort: "",
      },
      () => {
        this.props.cookies.remove("brand_filter", { path: "/", expires: 0 });
        this.props.cookies.remove("booth_cookies", { path: "/", expires: 0 });
        this.props
          .getBoothAll({
            perpage: this.state.perpage[this.state.filter_perpage],
            page: this.state.page,
            is_active: 1,
          })
          .then((e) => {
            if (e.code === 200) {
              if (e.data !== null) {
                this.setState({
                  data: e.data,
                  hasMore:
                    e.data.length !==
                    this.state.perpage[this.state.filter_perpage]
                      ? false
                      : true,
                });
              } else {
                this.setState({ data: [], hasMore: false });
              }
            } else {
              this.setState({ err: e.message });
            }
          })
          .catch((e) => {
            alert("Something Error");
          });
      }
    );
  };

  loadFunc = () => {
    let params = this.params();
    params.page = this.state.page + 1;
    const ctx = this;
    const nextpage = this.state.page + 1;
    this.props
      .getBoothAll(params)
      .then((e) => {
        if (e.code === 200) {
          ctx.setState({
            page: nextpage,
          });
          if (e.data !== null) {
            setTimeout(() => {
              ctx.setState({
                data: this.state.data.concat(e.data),
                hasMore:
                  e.data.length !==
                  this.state.perpage[this.state.filter_perpage]
                    ? false
                    : true,
              });
            }, 1500);
          } else {
            this.setState({ hasMore: false });
          }
        } else {
          ctx.setState({ err: e.message });
        }
      })
      .catch((e) => {
        alert("Something Error");
      });
  };

  render() {
    const url = this.props.match.url;
    var tableBody;

    if (this.state.data !== null) {
      tableBody = this.state.data.map((item, idx) => {
        let statusBooth = "Connecting...";
        if (this.props.socket.length !== 0) {
          let idxBooth = this.props.socket.findIndex(
            (p) => p.boothkey === item.boothkey
          );
          if (idxBooth > 0) {
            statusBooth = this.props.socket[idxBooth].state;
          } else {
            statusBooth = "Offline";
          }
        }

        return (
          <TableRow hover role="checkbox" tabIndex={-1} key={idx}>
            <TableCell sx={{ width: "1%", whiteSpace: "nowrap" }}>
              {(idx += 1)}
            </TableCell>
            <TableCell align="left">
              {item.brand !== null ? (
                <Chip
                  sx={{ fontSize: "11px" }}
                  label={item.brand?.name.toUpperCase()}
                  className={"brand-color-" + item.brand?.id}
                  size="small"
                />
              ) : (
                <Typography sx={{ fontSize: "11px", textAlign: "center" }}>
                  Need a Brand!
                </Typography>
              )}
            </TableCell>
            <TableCell align="left">{item.boothkey}</TableCell>
            <TableCell
              align="center"
              sx={{ width: "1%", whiteSpace: "nowrap" }}
            >
              IDR{item.price.toLocaleString("id")}
            </TableCell>
            <TableCell align="left">{item.name}</TableCell>
            <TableCell>{item.description}</TableCell>
            <TableCell align="center">
              <Chip
                sx={{ fontSize: "11px" }}
                variant="contained"
                size="small"
                color={statusBooth === "Offline" ? "error" : "success"}
                label={statusBooth.toUpperCase()}
              />
            </TableCell>
            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
              {/* width:"140px",  */}
              <Grid container gap={1} alignItems="center">
                {/* <Button size="small" variant="contained" color="error" onClick={(e)=>{
                                this.props.history.push(url+"/edit/"+item.boothkey);
                            }}>Sync</Button> */}
                <Button
                  size="small"
                  variant="contained"
                  color="warning"
                  disabled={
                    this.props.permissions.indexOf("edit booth") !== -1
                      ? false
                      : true
                  }
                  onClick={(e) => {
                    this.props.history.push(url + "/edit/" + item.boothkey);
                  }}
                >
                  Edit
                </Button>
              </Grid>
            </TableCell>
          </TableRow>
        );
      });
    }

    return (
      <Container className="main-panel booth">
        <Grid container className="header-panel" alignItems="center" mb={1}>
          <Grid item md={6} xs={6} sx={{ justifyContent: "flex-start" }}>
            <Typography variant="h6">
              {!this.props.title ? "" : this.props.title}
            </Typography>
          </Grid>
          <Grid item md={6} xs={6} sx={{ textAlign: "right" }}>
            <Stack direction={"row"} spacing={2} justifyContent="flex-end">
              {this.props.permissions.indexOf("read booth") !== -1 ? (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={(e) => {
                    this.props.history.push(url + "/archive");
                  }}
                >
                  Archive
                </Button>
              ) : null}
              {this.props.permissions.indexOf("create booth") !== -1 ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={(e) => {
                    this.props.history.push(url + "/add");
                  }}
                >
                  Add Booth
                </Button>
              ) : null}
            </Stack>
          </Grid>
        </Grid>
        <Grid
          container
          className="header-panel"
          alignItems="center"
          sx={{
            paddingTop: "10px",
            paddingBottom: "10px",
            marginBottom: "10px",
          }}
        >
          <Grid
            item
            md={12}
            sx={{
              display: "flex",
              gap: "10px",
              justifyContent: "flex-start",
              flexWrap: "wrap",
            }}
          >
            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel id="select-brand-label">Brand</InputLabel>
              <Select
                size="small"
                label="Brand"
                name="filter_idbrand"
                id="select-brand"
                labelId="select-brand-label"
                onChange={this.handleChangeFilter}
                value={this.state.filter_idbrand}
              >
                <MenuItem value={0} key={-1}>
                  All
                </MenuItem>
                {this.state.brand.map((item) => {
                  return (
                    <MenuItem value={item.id} key={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <TextField
              size="small"
              id="input-boothkey"
              name="filter_boothkey"
              label="Boothkey"
              placeholder="pp-bdo-umbira"
              onChange={this.handleChangeFilter}
              value={this.state.filter_boothkey}
            ></TextField>
            <TextField
              size="small"
              id="input-boothname"
              name="filter_name"
              label="Booth Name"
              placeholder="Umbira"
              onChange={this.handleChangeFilter}
              value={this.state.filter_name}
            ></TextField>
            <FormControl>
              <InputLabel id="select-perpage-label">Per Page</InputLabel>
              <Select
                size="small"
                label="Perpage"
                name="filter_perpage"
                id="select-perpage"
                labelId="select-perpage-label"
                onChange={this.handleChangeFilter}
                value={this.state.filter_perpage}
                sx={{ width: "100px" }}
              >
                {this.state.perpage.map((item, idx) => {
                  return (
                    <MenuItem value={idx} key={idx}>
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl size="small">
              <InputLabel id="select-perpage-label">Order By</InputLabel>
              <Select
                size="small"
                label="Order By"
                name="filter_order"
                id="select-order"
                labelId="select-order-label"
                onChange={this.handleChangeFilter}
                value={this.state.filter_order}
                sx={{ width: "100px" }}
              >
                {this.state.orderBy.map((item, idx) => {
                  return (
                    <MenuItem value={item.id} key={idx}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl size="small">
              <InputLabel id="select-perpage-label">Sort By</InputLabel>
              <Select
                size="small"
                label="Sort By"
                name="filter_sort"
                id="select-sort"
                labelId="select-sort-label"
                onChange={this.handleChangeFilter}
                value={this.state.filter_sort}
                sx={{ width: "100px" }}
              >
                {this.state.sortBy.map((item, idx) => {
                  return (
                    <MenuItem value={item.id} key={idx}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            {!this.state.is_loading ? (
              <Button
                ref={(button) => (this.buttonElement = button)}
                variant="contained"
                onClick={this.handleFilterSubmit}
              >
                Filter
              </Button>
            ) : (
              <Typography className="btn-loading-filter">
                HARAP SABAR...
              </Typography>
            )}
            <Button variant="contained" onClick={this.handleFilterClear}>
              Clear Filter
            </Button>
          </Grid>
        </Grid>
        <Paper>
          <TableContainer sx={{ maxHeight: 570 }}>
            <InfiniteScroll
              // id="infinite-scroll-component"
              height={500}
              dataLength={this.state.data.length}
              next={this.loadFunc}
              hasMore={this.state.hasMore}
              loader={
                <Typography
                  id="load-data"
                  sx={{
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    padding: "15px",
                  }}
                >
                  Loading...
                </Typography>
              }
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell>No.</TableCell>
                    <TableCell align="left">Brand</TableCell>
                    <TableCell align="left">Boothkey</TableCell>
                    <TableCell align="center">Price</TableCell>
                    <TableCell align="left">Name</TableCell>
                    <TableCell align="left">Description</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{tableBody}</TableBody>
              </Table>
            </InfiniteScroll>
          </TableContainer>
        </Paper>
      </Container>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getBrandAll: (data) => dispatch(getBrandAll(data)),
    getBoothAll: (data) => dispatch(getBoothAll(data)),
    getBoothSearch: (data) => dispatch(getBoothSearch(data)),
  };
}

const mapStateToProps = (state) => ({
  ...state,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withCookies(BoothAll))
);
